export function getIdContextKey(id: string, contextId?: string): string {
  return id + (contextId ? `-${contextId}` : '');
}
